/**
 * 彩票
 */
import { defineStore } from 'pinia';
import {
  accMul,
  arrayRemove,
  blackListFilter,
  checkInteger,
  dayEndTimeNew,
  dayStartTimeNew,
  displayCardcode,
  fixFloat,
  getBetPlatform,
  getDeviceType,
  getJSON,
  isMobile,
  moneyString,
  setJSON,
  utilsTotal,
} from '@star/utils';
import { ConfigUtils, ROUTER_MODE, Sports } from '@star/config';
import {
  ballsWithArea,
  createBasket,
  createPlan,
  getBasketItemCMD,
  getCurrentPlayRebate,
  isFrost,
  isPairBall,
  noteNum,
  parseWincode,
  sliptPlanWithSubPlay,
  startTime,
  stopTime,
  updateBasket,
} from '../helperPlay';
import network from '../network';
import { start } from '../../index';
import { mb_t } from '@star/languages';
import { helperHK } from '@star/helpers';
import betHistoryConfig from '../otherGames/betHistoryConfig';
import { useMsgStore } from '../message';
import { useTenantStore } from '../tenant';
import { useHaxiStore } from '../haxi';
import { useHot } from '../useHot';
import { useSportsStore } from '../sports';
import { useAppStore } from '../app';
import {
  GameChildTypesEnum,
  GameMainKeysEnum,
  GameMainTypesEnum,
  gameMenuTypesMap,
  LotteryTypeIdEnum,
  LotteryTypeKeysEnum,
  StorageKeysEnum,
} from '@star/constants';
import { filter, groupBy, includes, map } from 'lodash-es';
import { useSessionStorage, useUrlSearchParams } from '@vueuse/core';
import { gameServices } from '../services';

interface EventPayload {
  Market: number;
  SportId: number;
}

const getLanguageCode = locale => {
  const languageCodeObj = {
    cn: 'chs',
    en: 'eng',
    th: 'th',
    vi: 'vn',
    id: 'id',
    es: 'es',
  };
  return languageCodeObj[locale] || 'eng';
};

// IM体育单独处理
const formatIMSport = data => {
  const { hotData } = useHot();
  const { tenantInfo } = hotData;
  const proxy = Number(tenantInfo.value.proxy);
  const item = { ...data };
  let url = '';
  const tmp = tenantInfo.value.logo_manage.filter(items => items.message_id === 28 && items.pic_addr);
  if (tmp && tmp.length) {
    url = tmp[0].pic_addr;
  }
  if (+item.play_id === 931) {
    item.img_url = url;
    if (proxy === 0) {
      item.play_cname = tenantInfo.value.tenant.tenant_name;
    } else if (proxy === 1) {
      item.play_cname = tenantInfo.value.tenant.tenant_des;
    } else if (proxy === 2) {
      item.play_cname = tenantInfo.value.tenant.xmpp;
    }
  }
  return item;
};

const GAME_STORGAE_KEY = 'game-state';
const sportState = {
  currentMarket: Sports.GAME_MENU[0] as any, // 当前1级菜单选中的数据
  currentGame: 1, // 当前选中的游戏,默认足球=1
  currentBetData: null, // 当前下注项的内容
  betLeagueItemData: null,
  cross: {}, // 串关游戏, 最多10个
  cartMode: 0, // 0=不显示购物车;1=单注购物车;2=串关购物车
  currentMatchEvent: null, // 当前赛事id
  leaguSelected: [], // 联赛筛选ID
  selectedType: 1,
  selectedGameText: '',
  sportMenus: null as any, // 首页菜单个数
  eventsDetailLists: {}, // 所有赛事缓存列表
  guanjunDetailLists: {}, // 所有冠军赛事缓存列表
  game3LoginInfo: {} as any, // 登录IM体育第三方之后返回的token信息
  leagueSortType: 1, // 联赛排序 1=联赛; 2=时间
  leaguListStyle: 1, // 1=默认展开所有;2=收起明细,只展示联赛名
  hotEvents: [], // 热门赛事
  leagueDate: '', // 联赛过滤时间,适用于早盘
  currentGameShortInfo: {
    competitionName: '',
    homeTeam: '',
    awayTeam: '',
    eventDate: '',
  }, // 当前赛事简略信息
  currentHomeGameTab: 'lobby',
  myCollect: [], // 我的收藏列表
  appLoginPopType: 0, // 提示app下载弹窗模式 0 不弹 1 每日一次 2 只弹一次
  receiveAwardPopType: 0, // 提示登录后弹出领取奖励弹窗模式（新增加单独弹出窗口） 0 不弹 1 每日一次 2 只弹一次
  appLoginPop: false, // 用于判断如果是用户登录状态，判断是否需要再弹出下载app的提示窗口

  /**
   * 重构后数据
   * */
  activeHomeMainMenuTab: useSessionStorage<string>(StorageKeysEnum.APP_ACTIVE_MAIN_MENU_TAB, ''), // 首页一级菜单当前tab
  activeHomeSubMenuTab: useSessionStorage<string>(StorageKeysEnum.APP_ACTIVE_SUB_MENU_TAB, ''), // 首页二级菜单当前tab
  activeHomeChildMenuTab: useSessionStorage<GameChildTypesEnum | ''>(StorageKeysEnum.APP_ACTIVE_CHILD_MENU_TAB, ''), // 首页三级菜单当前tab
  reqHomeGamesDataLoading: true,
};

const query = useUrlSearchParams<{ subType: string; childType: string }>(ROUTER_MODE);

export const useGameStore = defineStore({
  id: 'game',
  state: () => {
    return {
      ...sportState,
      hallData: getJSON('hallData', true) || [], // 彩票大厅的数据
      allLotteryData: {}, // 所有彩票信息
      gameTabsData: [], // 游戏二级菜单数据（开元棋牌，RT电子...）
      gameTabSelectedType: 0, // 游戏二级菜单当前选中
      gameTabSelectedData: {},
      lotteryThird: {
        // 三方彩票
        DB: [], // DB 彩票
        SGWIN: [], // SGWin 彩票
        GPI: [], // GPI
        tianCheng: [], // 天成彩票
      },
      // lotteryThirdOpenStatus: {}, // 3方游戏开关状态
      menuSort: useSessionStorage<any[]>(StorageKeysEnum.APP_MAIN_MENU, []),
      isOpenCp: false, // 是否开启彩票
      isShowGPIBtn: false,
      isShowSBCPBtn: false,
      isShowDBCPBtn: false,
      planDetail: {} as any, // 方案详情
      currentPlayPlan: getJSON('currentPlayPlan') ? getJSON('currentPlayPlan') : {}, // 投注列表中要查看详情的那一期方案
      hotGames: [] as any[], // 热门游戏
      playGames: {}, // 第三方游戏数据
      chessPlayGames: {}, // 第三方棋牌游戏数据
      fishingPlayGames: {}, // 第三方捕鱼游戏数据
      qklPlayGames: {}, // 第三方区块链游戏数据
      playAllStates: {}, // 所有玩法状态
      qiPaiPlayGames: [], // 棋牌页面的大玩法棋牌列表
      dictGames: {},
      allGames: [], // 所有玩法
      gamesTry: [], // 试玩游戏
      gamesTryPlayIds: [], // 试玩游戏id
      gamesTryActive: 0, // 试玩游戏选中
      hasFakePG: false, // 是否有假PG
      playPlanList: {
        page_start: 1,
        data: [],
        count: 0,
        t: {},
      },
      playPricingPlan: {},
      gameTab: {}, // 玩法销售状态
      selectSliders: {}, // 选号界面滑块
      playDetails: {},
      termHistorys: {},
      terms: {},
      termsStatus: {},
      selectedBalls: {}, // 已选中的号码
      selectedBallsDetails: {}, // 已选中的号码详情
      baskets: {}, // 号码蓝
      singleTexts: {}, // 单式文本
      unitNumber: {}, // 投注单位 1:元 0.1:角 0.01:分 0.001:厘
      personalRebateStatus: {}, // 个人返点控制
      chips: {}, // 筹码
      selectMutex: {}, // 选号界面倍数
      updateBasketOut: null,
      publicMultix: {}, // 所有玩法投注页面底部组件倍数
      isAssignment: {}, // 是否给拉杆赋值
      charts: {}, // 走势图
      curRoom: {} as any,
      curRoomType: {} as any,
      roomChat: {},
      roomTypeId: 1,
      roomId: -1,
      backWaterList: [],
      backWaters: { 1: [], 2: [], 3: [] },
      betLimits: { 1: [{}, {}], 2: [{}, {}], 3: [{}, {}] },
      roomTypes: {},
      version_type: [], // 后台配置的热度展示tab
      smallClassGames: {} as any, // 热门分类游戏集合
      gameBigClass: {
        // 三方游戏大类
        [GameMainKeysEnum.CHESS]: [],
        [GameMainKeysEnum.ELECTRONIC]: [],
        [GameMainKeysEnum.SPORTS]: [],
        [GameMainKeysEnum.LIVE]: [],
        [GameMainKeysEnum.FISHING]: [],
        [GameMainKeysEnum.LOTTERY]: [],
        [GameMainKeysEnum.LOTTERY_ALL]: [],
        [GameMainKeysEnum.BLOCK_THIRD]: [],
        // chess: [],
        // electronic: [],
        // sports: [],
        // live: [],
        // fishing: []
      },
      newHotGames: [],
      profitList: [], // 盈利榜数据
      playRewardRank: { count: 0, data: [] }, // 中奖排行榜
      originalGamesMsg: {}, // 原创游戏推送消息
      originalGames: [], // 原创游戏
      hotGamesPlatform: null, // 首页热门游戏平台

      // 重构后的属性
    } as Record<string, any>;
  },
  getters: {
    // 获取冠军赛事列表
    getGuanjunLists: state => (eventIds: number[]) => {
      if (eventIds) {
        // 分类排序
        let _list = {};
        eventIds.map(v => {
          const _data = state.guanjunDetailLists[v];
          if (_data) {
            const title = _data.outrightEventName;
            const firstWord = title.substr(0, 1);
            if (/[A-Za-z]+/.test(firstWord) || Sports.CN_EN_MAP[firstWord]) {
              const upper = Sports.CN_EN_MAP[firstWord] || firstWord.toUpperCase();
              if (!_list[upper]) {
                _list[upper] = [];
              }
              _list[upper].push(_data);
            } else {
              if (!_list[firstWord]) {
                _list[firstWord] = [];
              }
              _list[firstWord].push(_data);
            }
          }
        });
        // 排序
        const keys = Object.keys(_list);
        const newList = {};
        keys.sort().map(v => {
          newList[v] = _list[v];
        });
        return newList;
      } else {
        return [];
      }
    },
    // 获取赛事明细列表
    getEventsLists: state => (eventIds: number[]) => {
      if (eventIds) {
        let _events: any = [];
        eventIds.map(v => {
          if (state.eventsDetailLists[v]) {
            _events.push(state.eventsDetailLists[v]);
          }
        });
        return _events;
      } else {
        return [];
      }
    },
    // 获取当前选中体育游戏的收藏赛事ids
    getGuanjunEventById: state => eventId => {
      return state.guanjunDetailLists[eventId];
    },

    /**
     * 重构后的属性
     * */
    // 游戏大类菜单
    gameMainClassList: state => {
      const { template } = useAppStore();
      return filter(
        state.menuSort,
        (item: any) => item.state == 1 && includes(gameMenuTypesMap[template], item.type)
      ).sort((a, b) => b.sort_v - a.sort_v);
    },
    // 是否有彩票大类
    isLotteryGroupMenu: state => {
      return includes(
        map(state.gameMainClassList, item => item.type),
        GameMainTypesEnum.LOTTERY
      );
    },
  },
  actions: {
    setActiveHomeMainMenuTab(key?: GameMainTypesEnum) {
      this.activeHomeMainMenuTab = key || '';
    },
    setActiveHomeSubMenuTab(key?: string) {
      this.activeHomeSubMenuTab = key || '';
      // query.subType = this.activeHomeSubMenuTab;
    },
    setActiveHomeChildMenuTab(key?: string) {
      this.activeHomeChildMenuTab = key || '';
      // query.childType = this.activeHomeChildMenuTab;
    },

    setGamesTryActive(value) {
      this.gamesTryActive = value;
    },

    changeSelectedType(data) {
      this.selectedType = data;
    },
    setSmallClassGame(data) {
      this.smallClassGames = data.data;
    },
    setGameAllStates(data) {
      let apaterData = {};
      if (data) {
        for (let key in data) {
          apaterData[key] = {
            play: {
              play_id: key,
              play_state: data[key],
            },
          };
        }
      }
      ConfigUtils.updateMainPlayStates(apaterData);
      let playConfig = ConfigUtils.getPlayConfig();
      let arr: any = [];
      let dict = {};
      for (let k in playConfig) {
        let play = Object.assign({}, playConfig[k]);
        if (play.enable) {
          arr.push(play);
          dict[play.id] = play;
        }
      }
      this.dictGames = dict;
      this.allGames = arr;
      this.playAllStates = Object.assign({}, apaterData);
    },
    setTermsStatus(data) {
      let newTermStatus = Object.assign({}, this.termsStatus);
      newTermStatus[data.key] = data.data;
      this.termsStatus = newTermStatus;
    },
    setTerms(data) {
      let terms = Object.assign({}, this.terms);
      terms[data.key] = data.data;
      if (!terms[data.key].time_zone && terms[data.key].time_zone !== 0) {
        // 附上默认时区值
        terms[data.key].time_zone = 8;
      } else if (typeof terms[data.key].time_zone === 'string') {
        try {
          terms[data.key].time_zone = parseInt(terms[data.key].time_zone);
        } catch (e) {
          terms[data.key].time_zone = 8;
        }
      }
      this.terms = terms;
    },
    setTermHistorys(data) {
      this.termHistorys = { ...this.termHistorys, ...data };
    },
    setPlayDetails(data) {
      let newPlayDetails = Object.assign({}, this.playDetails);
      let val = data.value;
      for (let i in val) {
        newPlayDetails[val[i].play_id] = val[i];
      }
      this.playDetails = newPlayDetails;
    },
    clearAllSelecteds() {
      this.selectedBalls = {};
      this.selectedBallsDetails = {};
      this.singleTexts = {};
    },
    clearSelecteds(payload) {
      let newSelectedBalls = Object.assign({}, this.selectedBalls);
      let newSelectedBallsDetails = Object.assign({}, this.selectedBallsDetails);
      let subPlay = ConfigUtils.getPlayInfo(payload.subPlayId);
      let ballinfo = ConfigUtils.getBallInfo(payload.subPlayId);
      let optionBalls: any[] = [];
      let optionDetails = {};
      let hasOptions = false;
      for (let i in ballinfo.areas) {
        let area = ballinfo.areas[i];
        if (area.isoption && area.option) {
          hasOptions = true;
          for (let j in area.option.balls) {
            let checkOption = {
              play_id: payload.subPlayId,
              ball_id: area.baseballid + area.option.balls[j],
              selected: true,
            };
            if (optionBalls.indexOf(checkOption.ball_id) === -1) {
              optionBalls.push(checkOption.ball_id);
            }
            optionDetails[checkOption.ball_id] = checkOption;
          }
        }
      }
      if (subPlay && subPlay.simplex) {
        if (hasOptions) {
          let cloneOptionArrays: any[] = [];
          for (let i in optionBalls) {
            cloneOptionArrays.push(ballinfo.balls[optionBalls[i]].cmd);
          }
          newSelectedBalls[payload.subPlayId] = [cloneOptionArrays.join('')];
        }
      } else {
        newSelectedBalls[payload.subPlayId] = optionBalls;
      }
      if (payload._clear) {
        newSelectedBalls[payload.subPlayId] = [];
      }
      newSelectedBallsDetails[payload.subPlayId] = optionDetails;
      this.selectedBalls = newSelectedBalls;
      this.selectedBallsDetails = newSelectedBallsDetails;
      let singleTexts = {};
      singleTexts[payload.subPlayId] = '';
      this.singleTexts = singleTexts;
    },
    selectedBall(payload) {
      let play = ConfigUtils.getPlayInfo(payload.subPlayId);
      let selecetBalls = this.selectedBalls[payload.subPlayId];
      if (selecetBalls == null) {
        selecetBalls = [];
      }
      let allAreaBalls = ballsWithArea(payload.subPlayId, selecetBalls);
      let ballinfo = ConfigUtils.getBallInfo(payload.subPlayId);

      let fanilSelected = (options: any = null) => {
        let data = {
          play_id: payload.subPlayId,
          ball_id: payload.ballId,
          selected: payload.selected,
          odds: payload.ballodds, // 赔率
          ball_multx: payload.ballMultx,
        };
        if (options) {
          for (let k in options as any) {
            data[k] = options[k];
          }
        }

        let playSelectedIds = this.selectedBalls[payload.subPlayId];
        if (playSelectedIds == null) playSelectedIds = [];
        playSelectedIds = Object.assign([], playSelectedIds);

        let playSelectedDetails = this.selectedBallsDetails[payload.subPlayId];
        if (playSelectedDetails == null) playSelectedDetails = {};
        playSelectedDetails = Object.assign({}, playSelectedDetails);

        let optionArrays: any[] = [];
        let optionBallArrays: any[] = [];
        if (play.simplex) {
          let oldDetails = this.selectedBallsDetails[payload.subPlayId];
          if (oldDetails) {
            for (let k in oldDetails) {
              let ball = ballinfo.balls[k];
              if (ball.isoption) {
                optionArrays.push(ball.cmd);
                optionBallArrays.push(ball);
              }
            }
          }
        }

        let ball = ballinfo.balls[data.ball_id];
        if (data.selected) {
          // 单式
          if (play.simplex && ball.isoption) {
            optionArrays.push(ball.cmd);
            optionArrays = optionArrays.sort();
            playSelectedIds[0] = optionArrays.join('');
          } else if (playSelectedIds.indexOf(data.ball_id) === -1) {
            playSelectedIds.push(data.ball_id);
          }
          playSelectedDetails[data.ball_id] = data;
        } else {
          // 单式
          if (play.simplex && ball.isoption) {
            let area = ballinfo.areas[ball.areaidx];
            if (optionArrays.length > area.option.min) {
              arrayRemove(optionArrays, ball.cmd);
              optionArrays = optionArrays.sort();
              playSelectedIds[0] = optionArrays.join('');
              delete playSelectedDetails[data.ball_id];
            }
          } else {
            arrayRemove(playSelectedIds, data.ball_id);
            delete playSelectedDetails[data.ball_id];
          }
        }
        let newSelectedBalls = Object.assign({}, this.selectedBalls);
        let newSelectedBallsDetails = Object.assign({}, this.selectedBallsDetails);

        newSelectedBalls[payload.subPlayId] = playSelectedIds;
        newSelectedBallsDetails[payload.subPlayId] = playSelectedDetails;
        this.selectedBalls = newSelectedBalls;
        this.selectedBallsDetails = newSelectedBallsDetails;
      };
      // 时时彩包胆
      if (play.note_tag === 'ssc2CombBaoDan' || play.note_tag === 'ssc3CombBaoDan') {
        fanilSelected();
      }
      // 香港彩连肖胆拖
      else if (play.note_tag.indexOf('xiaodt') === 1) {
        if (payload.selected) {
          // 胆码
          if (String(payload.ballId).indexOf('1') === 0) {
            if (allAreaBalls[0].length < ballinfo.areas[0].maxselect) {
              fanilSelected();
              let ballid = Number('2' + String(payload.ballId).substr(1, payload.ballId.length));
              fanilSelected({ ball_id: ballid, selected: false });
            }
          }
          // 拖码
          else if (String(payload.ballId).indexOf('2') === 0) {
            if (allAreaBalls[1].length < ballinfo.areas[1].maxselect) {
              let selectedDict = {};
              for (let i in selecetBalls) {
                selectedDict[selecetBalls[i]] = true;
              }
              // 胆码没选中的时候，拖码才可以选中
              let ballid = Number('1' + String(payload.ballId).substr(1, payload.ballId.length));
              if (!selectedDict[ballid]) {
                fanilSelected();
              }
            }
          }
        } else {
          fanilSelected();
        }
      } else if (play.note_tag === 'qianDX') {
        if (payload.selected) {
          let head = String(payload.ballId).indexOf('1') === 0 ? '2' : '1';
          let ballid = Number(head + String(payload.ballId).substr(1, payload.ballId.length));
          fanilSelected({ ball_id: ballid, selected: false });
          fanilSelected();
        } else {
          fanilSelected();
        }
      }
      // 胆拖
      else if (play.note_tag.indexOf('dtComb') === 0) {
        let num = Number(play.note_tag.substr(play.note_tag.length - 1));
        if (payload.selected) {
          if (String(payload.ballId).indexOf('1') === 0) {
            if (allAreaBalls[0].length >= num - 1) {
              fanilSelected({ ball_id: allAreaBalls[0][0].id, selected: false });
            }
            let ballid = Number('2' + String(payload.ballId).substr(1, payload.ballId.length));
            fanilSelected({ ball_id: ballid, selected: false });
          } else if (String(payload.ballId).indexOf('2') === 0) {
            let ballid = Number('1' + String(payload.ballId).substr(1, payload.ballId.length));
            fanilSelected({ ball_id: ballid, selected: false });
          }
          fanilSelected();
        } else {
          fanilSelected();
        }
      } else if (play.note_tag === '2hunpen') {
        if (payload.selected) {
          if (selecetBalls.length < 2) {
            fanilSelected();
          }
        } else {
          fanilSelected();
        }
      } else {
        // 各区域选号球数量限制
        if (payload.selected) {
          let index = Number(String(payload.ballId).substr(0, 1)) - 1;
          if (ballinfo.areas[index] && ballinfo.areas[index].maxselect) {
            if (allAreaBalls[index].length < ballinfo.areas[index].maxselect) {
              fanilSelected();
            }
          } else {
            fanilSelected();
          }
        } else {
          fanilSelected();
        }
      }
    },
    setSelectSliders(data) {
      if (data.value === 'NaN') data.value = '0';
      let newSliders = Object.assign({}, this.selectSliders);
      newSliders[data.key] = Math.floor(Number(data.value));
      this.selectSliders = newSliders;
    },
    setBasketItemsRebate(payload) {
      let key = payload.main_play_id;
      if (payload.key) {
        key = payload.key;
      }
      let cloneBaskets = Object.assign({}, this.baskets);
      let basket = cloneBaskets[key];
      if (basket == null) {
        basket = createBasket();
      }
      for (let k in basket.items) {
        let item = basket.items[k];
        item.rebate = payload.rebate;
      }
      updateBasket(basket);
      cloneBaskets[key] = basket;
      const newCloneBaskets = {};
      if (cloneBaskets[key]) {
        newCloneBaskets[key] = cloneBaskets[key];
      }
      if (cloneBaskets['final-' + key]) {
        newCloneBaskets['final-' + key] = cloneBaskets['final-' + key];
      }
      // helperStorage.write('baskets', JSON.stringify(newCloneBaskets))
      this.baskets = newCloneBaskets;
    },
    clearBasketWithPlayId(payload) {
      let key = payload.main_play_id;
      if (payload.key) {
        key = payload.key;
      }
      let cloneBaskets = Object.assign({}, this.baskets);
      cloneBaskets[key] = createBasket();
      const newCloneBaskets = {};
      if (cloneBaskets[key]) {
        newCloneBaskets[key] = cloneBaskets[key];
      }
      if (cloneBaskets['final-' + key]) {
        newCloneBaskets['final-' + key] = cloneBaskets['final-' + key];
      }
      this.baskets = newCloneBaskets;
    },
    clearBasketWithPlaysubId(payload) {
      let playid = payload.playid;
      let subplayid = payload.subplayid;
      let isSubSub = payload.isSubSub;
      if (!this.baskets[playid]) {
        return false;
      }
      let cloneBasket = JSON.parse(JSON.stringify(this.baskets[playid]));
      let _keys = cloneBasket.keys.filter(v => v !== String(subplayid));
      const last3 = Number(Number(subplayid) % 1000);
      console.log('cloneBasket', cloneBasket, _keys, last3, payload);
      if (!last3) {
        // 和值玩法
        const _data = cloneBasket.items[subplayid];
        if (_data.length === 1) {
          this.handleDeleteBasket(_keys, playid, subplayid, cloneBasket);
        } else {
          const ballId = Number(payload.unitBallId.split('-')[1]);
          const _showArray = _data.showArray.filter(v => v !== payload.ballName);
          delete _data.selected_odds[ballId];
          this.baskets = {
            ...this.baskets,
            [playid]: {
              ...this.baskets[playid],
              items: {
                ...cloneBasket.items,
                [subplayid]: {
                  ..._data,
                  ball_ids: _data.ball_ids.filter(v => v !== ballId),
                  showArray: _showArray,
                  showString: _showArray.join(','),
                },
              },
              total_note: this.baskets[playid].total_note - 1,
            },
          };
        }
      } else {
        this.handleDeleteBasket(_keys, playid, subplayid, cloneBasket);
      }
    },
    handleDeleteBasket(_keys, playid, subplayid, cloneBasket) {
      if (_keys.length) {
        delete cloneBasket.items[subplayid];
        this.baskets = {
          ...this.baskets,
          [playid]: {
            ...this.baskets[playid],
            keys: _keys,
            items: cloneBasket.items,
            total_note: this.baskets[playid].total_note - 1,
          },
        };
      } else {
        delete this.baskets[playid];
      }
    },
    setSelectMutex(data) {
      let newMutex = Object.assign({}, this.selectMutex);
      let strMutex = data.value + '';
      if (strMutex.length > 11) {
        data.value = Number(strMutex.slice(0, 11));
      }
      newMutex[data.key] = data.value;
      this.selectMutex = newMutex;
    },
    selectedIdsToBasket(payload) {
      let key = payload.main_play_id;
      if (payload.key) {
        key = payload.key;
      }
      let cloneBaskets = Object.assign({}, this.baskets);
      let mainPlay = ConfigUtils.getPlayInfo(payload.main_play_id);
      let subPlay = ConfigUtils.getPlayInfo(payload.subplayid);
      let rebate = getCurrentPlayRebate(payload.main_play_id); // 返点
      if (!rebate) {
        rebate = 0;
      }
      let multx = payload.multx;
      if (multx == null) {
        if (checkInteger(this.selectMutex[payload.main_play_id])) {
          multx = this.selectMutex[payload.main_play_id]; // 倍数
        }
      }
      let coefficient = this.unitNumber[payload.main_play_id]; // 价格系数 1：元 0.1：角 0.01：分 0.001厘
      if (coefficient == null) {
        coefficient = 1;
      }
      if (multx == null) {
        multx = 1;
      }
      let basket = cloneBaskets[key];
      if (basket == null) {
        basket = createBasket();
      }
      cloneBaskets[key] = basket;
      // 添加号码栏中的每一个项
      let addToList = (key, data) => {
        if (data.ball_ids != null) {
          if (basket.keys.indexOf(String(key)) === -1) {
            basket.keys.push(String(key));
          }
          data.key = key;
          data.amount = accMul(data.multx * data.note, data.unit_price, 0);
          data.play_cname = subPlay.play_cname;
          data.game_cname = mainPlay.play_cname;
          data.zName = payload.zName;
          basket.items[key] = data;

          // 投注号字符
          data.showArray = [];
          data.showString = '';
          data.chatString = '';
          // 是否单式
          if (subPlay.simplex) {
            data.showString = ' ' + data.ball_ids.join(',');
            let ballInfo = ConfigUtils.getBallInfo(data.subplayid);
            if (ballInfo.areas.length > 1) {
              let checkArea = ballInfo.areas[0];
              if (checkArea.isoption && data.ball_ids.length > 0) {
                data.showString = ' ';
                let checkBalls = data.ball_ids[0].split('');
                for (let chIdx in checkBalls) {
                  let ballId = Number(checkArea.baseballid) + Number(checkBalls[chIdx]);
                  // 聊天室展示
                  data.showString += ballInfo.balls[ballId].name + (ballInfo.balls[ballId].name ? ',' : '');
                }
                let selectNums = [];
                for (let ballIdx in data.ball_ids) {
                  if (Number(ballIdx) > 0) {
                    selectNums.push(data.ball_ids[ballIdx]);
                  }
                }
                data.showString += ',' + selectNums.join(',');
              }
            }
            data.chatString = data.showString;
          } else {
            let ballInfo = ConfigUtils.getBallInfo(data.subplayid);
            let chatString = '';
            for (let j = 0; j < ballInfo.areas.length; j++) {
              let names = [];
              for (let k in data.ball_ids) {
                let ball = ballInfo.balls[data.ball_ids[k]];
                if (ball && Number(ball.areaidx) === Number(j)) {
                  // 聊天室展示
                  data.showString += ball.name + (ball.name ? ',' : '');
                  names.push(ball.name);
                }
              }
              if (mainPlay.cat === 'MARKSIX') {
                chatString += names.join(' ');
                j < ballInfo.areas.length - 1 ? (chatString += ',') : (chatString += ' ');
              }
              j < ballInfo.areas.length - 1 ? (data.showString += ',') : (data.showString += ' ');
            }
            if (chatString.length > 0) {
              data.chatString = chatString;
            } else {
              data.chatString = data.showString;
            }
          }
          data.amountWithMode = data.multx + '(' + coefficient * subPlay.unit_price + '元)';
          data.showArray = data.showString.split(',');
        }
      };
      // 选中的球的赔率
      const selected_odds = {};
      if (payload.selected_odds) {
        payload.selected_ids.forEach(ids => {
          selected_odds[ids] = payload.selected_odds[ids]?.odds ?? '';
        });
      }

      if (subPlay.note_tag === 'ssc3CombSpecial') {
        let keyAdd = 0;
        for (let i in payload.selected_ids) {
          // 每个号码为一个ticket
          addToList(Number(payload.rom_key) + keyAdd, {
            subplayid: payload.subplayid,
            ball_ids: [payload.selected_ids[i]],
            selected_odds,
            rebate: rebate,
            multx: multx, // 投注倍数
            unit_price: subPlay.unit_price * coefficient, // 单注单价
            coefficient: coefficient,
            note: noteNum(payload.subplayid, [payload.selected_ids[i]]), // 注数
          });
          keyAdd++;
        }
      } else {
        addToList(payload.rom_key, {
          subplayid: payload.subplayid,
          ball_ids: payload.selected_ids,
          rebate: rebate,
          multx: multx, // 投注倍数
          odds: payload.odds,
          // 选中的ids的赔率
          selected_odds,
          unit_price: subPlay.unit_price * coefficient, // 单注单价
          coefficient: coefficient,
          note: noteNum(payload.subplayid, payload.selected_ids), // 注数
        });
      }
      clearTimeout(this.updateBasketOut);
      updateBasket(basket);
      const newCloneBaskets = {};
      if (cloneBaskets[key]) {
        newCloneBaskets[key] = cloneBaskets[key];
      }
      if (cloneBaskets['final-' + key]) {
        newCloneBaskets['final-' + key] = cloneBaskets['final-' + key];
      }
      // helperStorage.write('baskets', JSON.stringify(newCloneBaskets))
      this.baskets = newCloneBaskets;
    },
    setPublicMultix(data) {
      let newMultix = {};
      newMultix[data.key] = data.value;
      this.publicMultix = newMultix;
    },
    setBasketMutex(payload) {
      let key = payload.main_play_id;
      if (payload.key) {
        key = payload.key;
      }
      let cloneBaskets = Object.assign({}, this.baskets);
      let basket = cloneBaskets[key];
      if (basket == null) {
        basket = createBasket();
      }
      basket.multx = payload.mutex;
      updateBasket(basket);
      cloneBaskets[key] = basket;
      const newCloneBaskets = {};
      if (cloneBaskets[key]) {
        newCloneBaskets[key] = cloneBaskets[key];
      }
      if (cloneBaskets['final-' + key]) {
        newCloneBaskets['final-' + key] = cloneBaskets['final-' + key];
      }
      // helperStorage.write('baskets', JSON.stringify(newCloneBaskets))
      this.baskets = newCloneBaskets;
    },
    setPersonalRebateStatus(data) {
      let newData = JSON.parse(JSON.stringify(this.personalRebateStatus));
      this.personalRebateStatus = Object.assign(newData, data);
    },
    removeItemFromBasket(payload) {
      let key = payload.main_play_id;
      if (payload.key) {
        key = payload.key;
      }
      let cloneBaskets = Object.assign({}, this.baskets);
      let basket = cloneBaskets[key];
      if (basket == null) {
        basket = createBasket();
      }

      arrayRemove(basket.keys, String(payload.rom_key));
      delete basket.items[String(payload.rom_key)];
      updateBasket(basket);
      cloneBaskets[key] = basket;
      const newCloneBaskets = {};
      if (cloneBaskets[key]) {
        newCloneBaskets[key] = cloneBaskets[key];
      }
      if (cloneBaskets['final-' + key]) {
        newCloneBaskets['final-' + key] = cloneBaskets['final-' + key];
      }
      // helperStorage.write('baskets', JSON.stringify(newCloneBaskets))
      this.baskets = newCloneBaskets;
    },
    setUnitNumber(data) {
      let newUnit = Object.assign({}, this.unitNumber);
      newUnit[data.key] = data.value;
      this.unitNumber = newUnit;
    },
    setCharts(data) {
      let newCharts = Object.assign({}, this.charts);
      newCharts[data.key] = data.data;
      this.charts = newCharts;
    },
    setCurRoomType(data) {
      this.curRoomType = data;
      if (data && data.room_type_id) {
        this.roomTypeId = data.room_type_id;
      }
    },
    setCurRoom(data) {
      this.curRoom = data;
      if (data && data.play_room_id) {
        this.roomId = data.play_room_id;
      }
    },
    setRoomCat(data) {
      this.roomChat = data;
    },
    setChips(data) {
      let newChips = Object.assign({}, this.chips);
      let chip = data.value;
      if (chip.length > 0) {
        chip = parseInt(chip);
        if (chip < 1) {
          chip = 1;
        }
        let strChip = chip + '';
        if (strChip.length > 11) {
          strChip = strChip.slice(0, 11);
        }
        chip = Number(strChip);
        newChips[data.key] = chip;
        this.chips = newChips;
      } else {
        newChips[data.key] = chip;
        this.chips = newChips;
      }
    },
    setHallData(data) {
      this.hallData = data;
      setJSON('hallData', data, true);
    },
    // 清除体育缓存数据
    clearSportsData() {
      this.$state = {
        ...this.$state,
        ...sportState,
      };
    },
    setOriginalGamesMsg(data) {
      this.originalGamesMsg = data;
    },
    setOriginalGames(data) {
      this.originalGames = data
        .map(item => {
          return { ...item, isOriginal: true };
        })
        .sort((a, b) => b.hotVal - a.hotVal);
    },
    /** 获取方案列表
     * @param @requires payload.page_start 起始页
     * @param @requires payload.num_per_page 每页条数
     * @param payload.start_time 起始时间
     * @param payload.end_time 结束时间
     * @param payload.is_clear 是否清空本地数据(不清空则追加)
     * @param payload.key 本次请求的key，默认为default
     * @param payload.options 更多参数 JSON
     * @param payload.callback 回调 function (res, err) {}
     */
    async reqPlans(payload: any = {}) {
      const { hotData, activeConfiguration } = useHot();
      let isShow = activeConfiguration.value['30']; // 是否脱敏
      const { tenantInfo, userInfo } = hotData;
      if (payload.is_clear) {
        this.playPlanList = Object.assign({}, {}) as any;
      }
      const relateWeek = new Date(Date.now() - 1000 * 3600 * 24 * 7);
      const newPayload = JSON.parse(JSON.stringify(payload));
      if (newPayload.dataType !== 'reqPlansForm') {
        newPayload.cust_id = payload.cust_id || userInfo.value.cust_id; // 此处多个地方需要
        newPayload.plan_type = payload.plan_type || 1;
      } else {
        // 团队彩票
        newPayload.plan_type = payload.plan_type || '1,3';
      }
      newPayload.platform_order_id = newPayload.plan_id || '';
      delete newPayload['plan_id'];
      const ymd = new Date(Date.now());
      const data = {
        ...newPayload,
        tid: tenantInfo.value.tid,
        play_name: payload.play_name || '',
        page_start: payload.page_start || 1,
        num_per_page: payload.num_per_page || 10,
        start_time: payload.start_time ? dayStartTimeNew(payload.start_time) : dayStartTimeNew(relateWeek) + '',
        end_time: payload.end_time ? dayEndTimeNew(payload.end_time) : dayEndTimeNew(ymd) + '',
      };
      delete data.is_clear;
      try {
        const res: any = await network.request({
          cmdId: 320631,
          data: data,
        });
        if (res && res.type === 'success') {
          let sumRewardAmount = 0;
          let sumRebateAmount = 0;
          let sumReturnAmount = 0;
          let sumMoneyBuys = 0;
          if (res.data && res.data.data && res.data.data.length !== 0) {
            for (let i = 0; i < res.data.data.length; i++) {
              let tempData: any = {};
              tempData = res.data.data[i];
              res.data.data[i].profit = utilsTotal.moneyToFloat(
                tempData.reward_pretax + tempData.rebate_amount + tempData.return_amount - tempData.amount
              );
              // }
              if (isShow && newPayload.dataType === 'reqPlansForm') {
                res.data.data[i].cust_code =
                  res.data.data[i].cust_code.split('_')[res.data.data[i].cust_code.split('_').length - 1];
                res.data.data[i].cust_code = displayCardcode(res.data.data[i].cust_code, 1, 4);
                res.data.data[i].cust_name = displayCardcode(res.data.data[i].cust_name, 1, 4);
              }
              res.data.data[i].plan_time = utilsTotal.dateFormat(tempData.plan_time);
              sumMoneyBuys += tempData.amount;
              res.data.data[i].amount = utilsTotal.moneyToFloat(tempData.amount);
              sumRewardAmount += tempData.reward_pretax;
              sumRebateAmount += tempData.rebate_amount;
              sumReturnAmount += tempData.return_amount;
              res.data.data[i].reward_pretax = utilsTotal.moneyToFloat(tempData.reward_pretax);
              res.data.data[i].return_amount = utilsTotal.moneyToFloat(tempData.return_amount);
              res.data.data[i].moneyBuys = moneyString(tempData.amount);
              switch (tempData.state) {
                case 1:
                  res.data.data[i].stateStr = mb_t('未满员');
                  break;
                case 2:
                  res.data.data[i].stateStr = mb_t('已满员');
                  break;
                case 3:
                  res.data.data[i].stateStr = mb_t('送票中');
                  break;
                case 4:
                  res.data.data[i].stateStr = mb_t('已出票');
                  break;
                case 5:
                  res.data.data[i].stateStr = mb_t('已结算');
                  break;
                case 8:
                  res.data.data[i].stateStr = mb_t('已撤单');
                  break;
                case 9:
                  res.data.data[i].stateStr = mb_t('方案失败');
                  break;
                default:
              }
              if (tempData.plan_type !== 3) {
                switch (tempData.win_flag) {
                  case 2:
                    res.data.data[i].stateStr = mb_t('未中奖');
                    break;
                  case 3:
                    res.data.data[i].stateStr = mb_t('已中奖');
                    break;
                  case 4:
                    res.data.data[i].stateStr = mb_t('和局');
                    break;
                }
              } else if (tempData.state === 4) {
                res.data.data[i].stateStr =
                  tempData.disp_flag === 1
                    ? mb_t('追号中')
                    : tempData.disp_flag === 4
                      ? mb_t('已结束')
                      : mb_t('待付款');
              }
              res.data.data[i].revoke_flag = tempData.revoke_flag === 1 && tempData.state !== 8 ? 1 : 0;
              switch (res.data.data[i].dup_cat) {
                case 0:
                  res.data.data[i].dup_catStr = mb_t('默认');
                  break;
                case 1:
                  res.data.data[i].dup_catStr = mb_t('利润率追号');
                  break;
                case 2:
                  res.data.data[i].dup_catStr = mb_t('同倍追号');
                  break;
                case 3:
                  res.data.data[i].dup_catStr = mb_t('翻倍追号');
                  break;
                default:
              }
              // 追号信息
              if (tempData.plan_type === 3 || tempData.plan_type === '3') {
                res.data.data[i].reward = tempData.reward_aftertax
                  ? utilsTotal.moneyToFloat(tempData.reward_aftertax)
                  : 0;
                res.data.data[i].win_endStr = tempData.win_end === 1 ? mb_t('是') : mb_t('否');
                res.data.data[i].rebateAmount = moneyString(utilsTotal.moneyToFloat(tempData.rebate_amount));
                res.data.data[i].rewardAmount = moneyString(fixFloat(tempData.reward_pretax));
                res.data.data[i].returnAmount = moneyString(utilsTotal.moneyToFloat(tempData.return_amount));
              }
            }
          }
          if (res.data.t) {
            res.data.t.profit = utilsTotal.moneyToFloat(
              sumRewardAmount - sumMoneyBuys + sumRebateAmount + sumReturnAmount
            );
            res.data.t.sumRewardAmount = fixFloat(utilsTotal.moneyToFloat(sumRewardAmount));
            res.data.t.sumRebateAmount = fixFloat(utilsTotal.moneyToFloat(sumRebateAmount));
            res.data.t.sumReturnAmount = fixFloat(utilsTotal.moneyToFloat(sumReturnAmount));
            res.data.t.sumMoneyBuys = fixFloat(utilsTotal.moneyToFloat(sumMoneyBuys));
            // 原本就有的进行转换
            res.data.t.play_amount = fixFloat(utilsTotal.moneyToFloat(res.data.t.play_amount));
            res.data.t.award_amount = fixFloat(utilsTotal.moneyToFloat(res.data.t.award_amount));
            res.data.t.rebate_amount = fixFloat(utilsTotal.moneyToFloat(res.data.t.rebate_amount));
            res.data.t.return_amount = fixFloat(utilsTotal.moneyToFloat(res.data.t.return_amount));
            res.data.t.profit_amount = fixFloat(utilsTotal.moneyToFloat(res.data.t.profit_amount));
          } else {
            res.data.t = {};
            res.data.t.play_amount = false;
            res.data.t.profit = utilsTotal.moneyToFloat(
              sumRewardAmount - sumMoneyBuys + sumRebateAmount + sumReturnAmount
            );
            res.data.t.sumRewardAmount = fixFloat(utilsTotal.moneyToFloat(sumRewardAmount));
            res.data.t.sumRebateAmount = fixFloat(utilsTotal.moneyToFloat(sumRebateAmount));
            res.data.t.sumReturnAmount = fixFloat(utilsTotal.moneyToFloat(sumReturnAmount));
            res.data.t.sumMoneyBuys = fixFloat(utilsTotal.moneyToFloat(sumMoneyBuys));
          }
          if (payload.is_clear !== 2 && payload.dataType !== 'reqPlansForm') {
            this.playPlanList = Object.assign({}, res.data);
          }
          return Promise.resolve(res.data);
        } else {
          this.playPlanList = Object.assign({}, {}) as any;
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    /** 取消订单
     * @param @requires payload.plan_id
     * @param @requires payload.part_mon
     * @param @requires payload.ori_state
     * @param payload.key 本次请求的key，默认为default
     * @param payload.options 更多参数 JSON
     * @param payload.callback 回调 function (res, err) {}
     */
    async reqCancelPlan(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = {
        tid: tenantInfo.value.tid,
        oper_code: userInfo.value.cust_code,
        state: 8,
        plan_id: payload.plan.plan_id,
        ori_state: payload.plan.state,
        part_mon: payload.plan.part_mon,
      };
      try {
        const res: any = await network.request({
          cmdId: 320611,
          data: data,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success') {
          const sportsStore = useSportsStore();
          sportsStore.reqBlanceCollect();
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 设置收藏
    async setPlayCollection(
      payload: any = {
        data: {},
      }
    ) {
      const { hotData } = useHot();
      const { userInfo, tenantInfo } = hotData;
      const { play_id, type, _type, play_cat, play_collection } = payload.data;
      if (!payload.data.upper_id) {
        payload.data.upper_id = payload.data.upper_play_id;
      }
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
        play_id,
        type: _type || type,
        play_cat: typeof play_cat === 'number' ? play_cat : 1,
        status: play_collection,
        msg: JSON.stringify(payload.data),
      };
      try {
        const res = await network.request({
          cmdId: 320567,
          data,
        });
        if (res && res.type === 'success') {
          payload.callback && payload.callback(res.data);
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 收藏列表
    async getPlayCollection() {
      const { hotData } = useHot();
      const { userInfo, tenantInfo } = hotData;
      // 发起请求
      const postdata = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res = await network.request({
          cmdId: 320566,
          data: postdata,
        });
        if (res && res.type === 'success') {
          this.myCollect = res.data;
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 获取带租户玩法状态的玩法列表
    async reqPlayGames(payload: any = {}) {
      const { hotData } = useHot();
      const { userInfo, tenantInfo } = hotData;
      // 发起请求
      const postdata = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id || 0,
      } as any;
      if (payload && payload.isDz) {
        postdata.upper_id = '-1';
      } else if (payload && payload.isBy) {
        postdata.upper_id = '-2';
      } else if (payload && payload.isQp) {
        postdata.upper_id = '0';
      } else if (payload && payload.isQkl) {
        postdata.upper_id = '-3';
      }
      try {
        const res = await network.request({
          cmdId: 320146,
          data: postdata,
          headerType: 2,
          paramType: 0,
          isApiV2: true,
        });
        console.log('320146', res);
        if (res && res.type === 'success') {
          if (payload.isDz) {
            this.playGames = res.data;
          } else if (payload.isBy) {
            this.fishingPlayGames = res.data;
          } else if (payload.isQp) {
            this.chessPlayGames = res.data;
          } else if (payload.isQkl) {
            this.qklPlayGames = res.data;
          }
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 添加收藏
    async collect(payload: any = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      // 发起请求
      const postdata = {
        ...payload,
        tid: tenantInfo.value.tid,
        Token: this.game3LoginInfo.Token,
        MemberCode: this.game3LoginInfo.MemberCode,
        type: 'IM',
      };
      try {
        const res = await network.request({
          cmdId: 3119659,
          data: postdata,
          headerType: 2,
          paramType: 0,
          isApiV2: false,
        });
        if (res && res.type === 'success' && res.data) {
          // 更新关注数据
          Sports.GAME_MENU.map((v, index) => {
            // 关注
            if (v.key === 4) {
              // 更新收藏列表
              this.sportMenus[index]['totalGame'] += 1;
              this.sportMenus[index]['submenu'][payload.SportId] += 1;
            }
          });
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 下注
    async bet(payload = {}) {
      // 发起请求
      const postdata = {
        // tid: tenantInfo.value.tid,
        Token: this.game3LoginInfo.Token,
        MemberCode: this.game3LoginInfo.MemberCode,
        // type: 'IM',
        WagerType: 1, // 指投注性质 1 = Single 单注;  2 = Combo 连串过关
        CustomerIP: '192.168.10.11', //客户 IP 地址
        ServerIP: '192.168.14.128', //伺服器 IP 地址
        CustomerMACAddress: null, //客户 MAC 地址
        UserAgent: 'Mozilla', //用户代理字符
        AppDeviceName: null, //设备名. 只强制客户端渠道
        AppModel: null, //设备型号. 只强制客户端渠道
        AppOSVersion: null, //OS 版设备. 只强制客户端渠道
        AppPlatform: null, //设备平台. 只强制客户端渠道
        AppVersion: null, //客户端版本. 只强制客户端渠道
        IsComboAcceptAnyOdds: false, //指出会员投注时出现赔率变更并是否接受任何赔率。默认是只接受跟高的赔率
        WagerSelectionInfos: [], //投注选项详情清单
        ComboSelections: [], //连串过关选项清单
        TimeStamp: new Date().valueOf(), //新生成的时间戳将持续 5 分钟
        LanguageCode: 1, //使用会员语言投注
        IsCombo: false, //指出计数是连串过关赛事或者非连串过关赛事。
        ...payload,
      };
      try {
        const res: any = await network.request({
          cmdId: 3119656,
          data: postdata,
          headerType: 2,
          paramType: 1,
          isApiV2: false,
        });
        if (res.data?.statusCode === 100) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 获取投注记录列表信息
     */
    async reqBetHistoryList(payload) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;

      const data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: payload.cust_id || userInfo.value.cust_id,
        num_per_page: payload.num_per_page,
        page_start: payload.page_start,
        start_time: payload.start_time,
        end_time: payload.end_time,
        type_id: payload.type_id,
      };
      payload.time_type && (data.time_type = payload.time_type);
      payload.platform && (data.platform = payload.platform);
      console.log(
        {
          cmdId: 314502,
          data: data,
        },
        'payloaddata'
      );
      try {
        const res = await network.request({
          cmdId: 314502,
          data: data,
        });
        if (res && res.type === 'success') {
          // 字段统一化处理
          const resData: any = res.data || {};
          if (resData && resData.count > 0) {
            resData.data.map(item => {
              const gameInfo = ConfigUtils.getPlayInfo(item.play_type_id);
              let playTypeId = item.play_cname || (gameInfo ? gameInfo.play_cname : item.play_type_id);
              let { gameTypeId, platformOrderId, profitLoss } = betHistoryConfig.formatValue(
                item.play_type_id,
                item,
                playTypeId
              );
              let platformOrderId2 = platformOrderId ? platformOrderId : item.platform_order_id;
              item.playTypeId = playTypeId;
              item.gameTypeId = item.game_type_cname || gameTypeId || item.game_type_id;
              item.platform_order_id = platformOrderId2;
              item.profit_loss = profitLoss;
            });
          }
          return Promise.resolve(resData);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    // 个人报表列表接口
    async getReqUserReportList(payload) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;

      const data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      console.log(data, 'getReqUserReportList');
      try {
        const res: any = await network.request({
          cmdId: 3809567,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    // 交易明细接口
    async getByFrontList(payload: any) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;

      const data = {
        ...payload,
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id,
      };
      try {
        const res: any = await network.request({
          cmdId: 340539,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },

    async getGamesBigTypeData() {
      try {
        const { hotData } = useHot();
        const { tenantInfo } = hotData;
        const res: any = await gameServices.getGamesBigTypeData({ tid: tenantInfo.value.tid });
        if (res && res.type === 'success' && res.data) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        console.error(error);
        return Promise.reject(error.data);
      }
    },
    // 获取游戏大类平台数据 reset为真重新请求
    async getTotalGamesPlatform(payload: any) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      const msgStore = useMsgStore();
      const haxiStore = useHaxiStore();
      const gameStore = useGameStore();
      const tenantStore = useTenantStore();
      if (!tenantInfo.value.tid) return;
      const data = {
        tid: tenantInfo.value.tid,
        aseq: {
          aseq: start.aseqId,
        },
        version_type: {
          version_type: payload.type ? payload.type : 3, // 1 是棋牌, 2 是网赚 3, 是综合彩票
        },
        news: {
          page_start: 1,
          num_per_page: payload?.news?.num_per_page || 999,
          chan_con: payload.chan_con || 8,
          state: 1,
          message_id: '10,13', //10公告  13 跑马灯
          sort_flag: 1,
          vip_level: 0, //userInfo.value.cust_level || 0,
          proxy: tenantInfo.value.proxy,
          apply: 8, // 1 棋牌；2 网赚；3 综合彩票；3 老版彩票； (apply后端设置默认为1，为可选参数)
          language: 0, //Number(window.localStorage.getItem('languageNum') || '0'),
        },
        game_news: {
          page_start: 1,
          num_per_page: 9999,
          state: 1,
          message_id: 17,
          sort_flag: 1,
          tid: tenantInfo.value.tid,
          proxy: tenantInfo.value.proxy,
          chan_con: 0,
          apply: 8,
          ma_id: 10,
          vip_level: userInfo.value.cust_level || 0,
          type: getDeviceType(),
          language: Number(window.localStorage.getItem('languageNum') || '0'),
        },
        banners: {
          page_start: 1,
          num_per_page: payload?.banners?.num_per_page || 999,
          chan_con: payload.chan_con || 8,
          state: 1,
          message_id: 12,
          sort_flag: 1,
          tid: tenantInfo.value.tid,
          proxy: tenantInfo.value.proxy,
          apply: 8,
          location: '1',
          type: getDeviceType(),
          language: Number(window.localStorage.getItem('languageNum') || '0'),
        },
        homeHotGames: {
          cust_id: userInfo.value.cust_id || '0',
        },
        proxyConfig: {
          proxy: tenantInfo.value.proxy,
        },
        hotGames: {
          size: 12,
        },
      };
      try {
        this.reqHomeGamesDataLoading = true;
        console.log('getTotalGamesPlatform---post--->', data);
        const res: any = await gameServices.getHomeGamesData(data);
        console.log(res, 'getTotalGamesPlatform');

        if (res && res.type === 'success' && res.data) {
          // 设置注册弹窗
          this.appLoginPopType = res.data.appLoginPopType || 0;
          this.receiveAwardPopType = res.data.receiveAwardPopType || 0;
          this.appLoginPop = res.data.appLoginPop || false;
          // 菜单排序
          this.version_type = res.data.version_type
            .filter(item => item.sort_v !== 0)
            .sort((a, b) => {
              return b.sort_v - a.sort_v;
            });
          // todo 重复排序字段
          this.menuSort = this.version_type;
          // 是否开启cp
          this.isOpenCp = this.version_type.some((v: any) => v.type === 2);
          // 所有游戏销售状态
          gameStore.setGameAllStates(res.data.gameState);
          if (payload.updateNews) {
            // 公告
            msgStore.setNewLists(res.data.news.data);
            // 游戏公告
            msgStore.setGameNewsLists(res.data?.game_news?.data);
          }

          // 轮播图
          const homeBanner = res.data.banners?.data?.filter((item: { content1: string }) => item.content1 === '1');
          const mineBanner = res.data.banners?.data?.filter((item: { content1: string }) => item.content1 === '2');
          msgStore.setBanners(homeBanner || []);
          msgStore.setBanners2(mineBanner || []);

          // 原创游戏
          if (res.data.originalGames) {
            this.setOriginalGames(res.data.originalGames);
          }
          // 区块链游戏
          if (res.data.hsGames) {
            haxiStore.setHaxiGames(res.data.hsGames);
          }
          // 试玩游戏
          if (res.data.gamesTry) {
            this.gamesTry = res.data.gamesTry;
            const _gamesTryPlayIds = [];
            res.data.gamesTry.map((item: any) => {
              if (item.subList.length) {
                item.subList.map((subItem: any) => {
                  // @ts-ignore
                  _gamesTryPlayIds.push(Number(subItem.play_id));
                });
              }
            });
            this.gamesTryPlayIds = _gamesTryPlayIds;
          }

          // 存在假PG的时候不显示真pg 假PG=1382,真PG=1380
          const hasFakePG = res.data.thirdGames.find(v => v.play_id === 1382) || false;
          this.hasFakePG = !!hasFakePG;
          // 首页热门游戏
          let newDada: any = {};
          if (res.data.homeHotGames) {
            let arr = res.data.homeHotGames[1];

            if (hasFakePG) {
              arr = arr.filter(v => v.upper_play_id !== 1380);
            }
            this.newHotGames = arr;
            for (let key in res.data.homeHotGames) {
              if (Number(key) === 1) {
                newDada.hotGames = res.data.homeHotGames[key];
              } else if (Number(key) === 2) {
                newDada.hotElectronic = res.data.homeHotGames[key];
              } else if (Number(key) === 3) {
                newDada.hotFishing = res.data.homeHotGames[key];
              } else if (Number(key) === 4) {
                newDada.redEnvelope = res.data.homeHotGames[key];
              } else if (Number(key) === 5) {
                newDada.hotChess = res.data.homeHotGames[key];
              } else if (Number(key) === 6) {
                // 原创游戏
                newDada.hotOriginGames = res.data.homeHotGames[key];
              } else if (Number(key) === 7) {
                // 哈希游戏
                newDada.hotHash = res.data.homeHotGames[key];
              } else if (Number(key) === 8) {
                // 3方区块链游戏
                newDada.hotBlockThird = res.data.homeHotGames[key];
              }
            }
          }
          if (hasFakePG) {
            newDada.hotElectronic = newDada.hotElectronic.filter(v => v.upper_play_id !== 1380);
          }
          if (
            newDada.hotGames ||
            newDada.hotElectronic ||
            newDada.hotFishing ||
            newDada.redEnvelope ||
            newDada.hotChess ||
            newDada.hotBlockThird
          ) {
            this.setSmallClassGame({ data: newDada });
          }
          // 代理盘配置
          // console.log('res.data.proxyConfig', res.data.proxyConfig);
          tenantStore.setActiveConfiguration(res.data.proxyConfig);
          // 热门棋牌
          this.hotGames = blackListFilter(
            res.data.hotGames,
            // @ts-ignore
            userInfo.blacklist_game,
            // @ts-ignore
            userInfo.cust_name
          ) as any;
          // 热门棋牌游戏状态
          window.localStorage.setItem('QiPaiPlayGames', JSON.stringify(res.data.thirdQiPaiGames));
          this.qiPaiPlayGames = res.data.thirdQiPaiGames;
          // 所有第三方游戏大类数据
          const gameBigClass = {
            [GameMainKeysEnum.CHESS]: [],
            [GameMainKeysEnum.ELECTRONIC]: [],
            [GameMainKeysEnum.SPORTS]: [],
            [GameMainKeysEnum.LIVE]: [],
            [GameMainKeysEnum.FISHING]: [],
            [GameMainKeysEnum.BLOCK_THIRD]: [],
            // chess: [],
            // electronic: [],
            // sports: [],
            // live: [],
            // fishing: [],
          } as any;
          const groupByType = groupBy(res.data.thirdGames, item => item.big_type);
          console.log(groupByType, 'groupByType');
          res.data.thirdGames.forEach(item => {
            if (item.big_type) {
              switch (item.big_type) {
                case 1:
                  gameBigClass[GameMainKeysEnum.CHESS].push(item);
                  break;
                case 2:
                  if ((hasFakePG && item.play_id !== 1380) || !hasFakePG) {
                    gameBigClass[GameMainKeysEnum.ELECTRONIC].push(item);
                  }
                  break;
                case 3:
                  gameBigClass[GameMainKeysEnum.FISHING].push(item);
                  break;
                case 4:
                  gameBigClass[GameMainKeysEnum.LIVE].push(item);
                  break;
                case 5:
                  gameBigClass[GameMainKeysEnum.SPORTS].push(formatIMSport(item));
                  break;
                case 10:
                  gameBigClass[GameMainKeysEnum.BLOCK_THIRD].push(item);
                  break;
              }
            }
          });
          gameBigClass[GameMainKeysEnum.LOTTERY] = groupByType?.[7] || [];
          console.log('gameBigClass', gameBigClass);
          this.gameBigClass = gameBigClass;
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      } finally {
        this.reqHomeGamesDataLoading = false;
      }
    },
    // 获取首页热门游戏平台
    async getHotGamesPlatform() {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;

      if (!tenantInfo.value.tid) return;
      const data = {
        tid: tenantInfo.value.tid,
        cust_id: userInfo.value.cust_id || 0,
      };
      try {
        const config = await network.request({
          cmdId: 370730,
          data: {
            tid: tenantInfo.value.tid,
            option_code: 'OPEN_HOT_PLATFORM',
          },
        });

        // 开关未开启不查询热门平台
        if (config.data.value !== '1') return;

        const res: any = await gameServices.getHomeHotGamesData(data);

        if (res && res.type === 'success' && res.data) {
          this.hotGamesPlatform = res.data;
        }
        return Promise.resolve(res?.data);
      } catch (error: any) {
        console.error(error);
        // return Promise.reject(error.data);
      }
    },
    // 检测3方平台
    async checking3Game(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;

      const data = {
        ...payload,
        tid: tenantInfo.value.tid,
      };
      try {
        const res = await network.request({
          cmdId: 321543,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 检测3方游戏余额限制
    async checking3GameLimited(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;

      const data = {
        ...payload,
        tid: tenantInfo.value.tid,
      };
      try {
        const res = await network.request({
          cmdId: 315605,
          data: data,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 获取第三方平台跳转url
    async get3GameUrl(payload) {
      const { hotData } = useHot();
      const sportsStore = useSportsStore();
      const { tenantInfo, userInfo } = hotData;
      const data = payload.data ? { ...payload.data } : {};
      data.tid = tenantInfo.value.tid;
      data.cust_id = userInfo.value.cust_id;
      data.play_id =
        payload.play_id ||
        (payload.introduction
          ? payload.introduction.id || payload.introduction.default || payload.introduction.route
          : '');
      if (payload.type) {
        data.type = payload.type;
      }
      data.isMobileOpen = isMobile() ? 1 : 0;
      data.isMobileOpenNew = isMobile() ? 1 : 0;
      const params = payload.params ? { ...payload.params } : {};
      // data.params = JSON.stringify({
      //   type: params.type,
      //   big_type: params.big_type,
      //   play_id: params.play_id,
      //   upper_id: params.upper_id || params.play_id,
      //   main_id: params.main_id || params.play_id,
      //   play_cat: params.play_cat,
      //   play_name: params.play_name,
      //   play_cname: params.play_cname,
      //   gtype: params.gtype,
      // });
      try {
        const res = await network.request({
          cmdId: 314501,
          data: data,
          paramType: 0,
          isApiV2: true,
        });
        console.log('get3GameUrl', res, payload, data);
        if (res && res.type === 'success') {
          setTimeout(() => sportsStore.reqBlanceCollect(), 1000);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 获取试玩第三方平台跳转url
    async getTry3GameUrl(payload) {
      const { hotData } = useHot();
      const sportsStore = useSportsStore();
      const { tenantInfo, userInfo } = hotData;
      const data = payload.data ? { ...payload.data } : {};
      data.tid = tenantInfo.value.tid;
      data.cust_id = 0;
      data.play_id =
        payload.play_id ||
        (payload.introduction
          ? payload.introduction.id || payload.introduction.default || payload.introduction.route
          : '');
      if (payload.type) {
        data.type = payload.type;
      }
      data.isMobileOpen = isMobile() ? 1 : 0;
      data.isMobileOpenNew = isMobile() ? 1 : 0;
      try {
        const res = await network.request({
          cmdId: 314521,
          data: data,
          paramType: 0,
          isApiV2: true,
          inHeaders: { cust_id: 0 },
        });
        console.log('getTry3GameUrl', res, payload, data);
        if (res && res.type === 'success') {
          // setTimeout(() => sportsStore.reqBlanceCollect(), 1000);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 购彩大厅数据请求
     */
    async purchaseHall(payload) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      try {
        let data = {
          ...payload,
          cust_id: userInfo.value.cust_id || '',
          tid: tenantInfo.value.tid,
        };
        const res: any = await gameServices.getLotteryData({
          ...payload,
          cust_id: userInfo.value.cust_id || '',
          tid: tenantInfo.value.tid,
        });
        console.warn('lottery all', res, data);
        if (res?.type === 'success') {
          const _DB: any = [];
          const _GPI: any = [];
          const _SGWIN: any = [];
          // 过滤用户的黑名单游戏
          const resData = blackListFilter(
            res.data || [],
            // @ts-ignore
            userInfo.blacklist_game,
            // @ts-ignore
            userInfo.cust_name
          ) as any;
          for (let i = 0; i < resData.length; i++) {
            const obj = {
              stop_sale_offset: resData[i].stop_sale_offset,
              end_time: resData[i].end_time,
              db_sys_date: resData[i].sys_time,
            };
            resData[i].timeout = false;
            resData[i].stopTime = stopTime(obj);

            // 获取全部彩票
            if (payload.type === 0) {
              if (resData[i].type === LotteryTypeKeysEnum.GPI) {
                _GPI.push({
                  ...resData[i],
                  platformId: LotteryTypeIdEnum.GPI,
                });
              } else if (resData[i].type === LotteryTypeKeysEnum.DB) {
                _DB.push({
                  ...resData[i],
                  platformId: LotteryTypeIdEnum.DB,
                });
              } else if (resData[i].type === LotteryTypeKeysEnum.SGWIN) {
                _SGWIN.push({
                  ...resData[i],
                  platformId: LotteryTypeIdEnum.SGWIN,
                });
              }
            }
          }

          const _newData = resData.filter(v => v.play_state !== 3);

          // 全部彩票
          if (payload.type === 0) {
            this.lotteryThird.GPI = _GPI.filter(v => v.play_state !== 3);
            this.lotteryThird.DB = _DB.filter(v => v.play_state !== 3);
            this.lotteryThird.SGWIN = _SGWIN.filter(v => v.play_state !== 3);
            // TODO 是否要全部彩票
            const platformLottery = _newData.filter(
              v => ![LotteryTypeKeysEnum.DB, LotteryTypeKeysEnum.GPI, LotteryTypeKeysEnum.SGWIN].includes(v.type)
            );
            this.setHallData(platformLottery);
            this.gameBigClass[GameMainKeysEnum.LOTTERY] = platformLottery;
            // console.log('platformLottery', platformLottery)
          } else {
            this.setHallData(_newData);
            this.gameBigClass[GameMainKeysEnum.LOTTERY] = _newData;
          }

          return Promise.resolve(_newData);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 请求玩法定价方案(赔率)
     */
    async reqPlayPricingPlan(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      try {
        const res = await network.request({
          cmdId: 330951,
          data: [payload.play_id, payload.room_level, tenantInfo.value.tid],
          paramType: 2,
          timeout: payload.timeout || 1000 * 20,
        });
        if (res && res.type === 'success') {
          let newPlayPricingPlan = Object.assign({}, this.playPricingPlan);
          newPlayPricingPlan[payload.play_id + '-' + payload.room_level] = res.data;
          this.playPricingPlan = newPlayPricingPlan;
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 检测玩法是否可玩
     */
    async testCanPlay(payload) {
      let play = ConfigUtils.getPlayInfo(payload.main_play_id);
      let getSec = (hours, min, sec) => {
        let retsec = Number(hours) * 60 * 60 * 1000;
        retsec += Number(min) * 60 * 1000;
        retsec += Number(sec) * 1000;
        return retsec;
      };
      let testTimeArr = timeArr => {
        if (timeArr == null) {
          return false;
        }
        let date = new Date();
        let curSec = getSec(date.getHours(), date.getMinutes(), date.getSeconds());
        let leftArr = timeArr[0].split(':');
        let rightArr = timeArr[1].split(':');
        let leftTime = getSec(leftArr[0], leftArr[1], leftArr[2]);
        let rightTime = getSec(rightArr[0], rightArr[1], rightArr[2]);
        let isInTime = true;
        if (leftTime > rightTime) {
          isInTime = curSec > leftTime || curSec < rightTime;
        } else {
          isInTime = curSec > leftTime && curSec < rightTime;
        }
        return isInTime;
      };
      let isInTime = true;
      let timeStr = '';
      if (play && play.time) {
        // 私彩销售时间优先采用后端数据 sell_start_time sell_end_time
        if (play.base && play.sell_start_time && play.sell_end_time) {
          if (play.sell_end_time === '00:00:00') {
            play.time = [play.sell_start_time, '24:00:00'];
          } else {
            play.time = [play.sell_start_time, play.sell_end_time];
          }
        }
        isInTime = testTimeArr(play.time);
        if (!isInTime) {
          timeStr = play.time[0] + ' ~ ' + play.time[1] + '';
          if (play.time2) {
            isInTime = testTimeArr(play.time2);
            if (!isInTime) {
              timeStr += '、' + play.time2[0] + ' ~ ' + play.time2[1] + '';
            }
          }
        }
      }

      if (!isInTime) {
        return Promise.reject({ level: 2, des: '已停盘，开盘时间为:' + timeStr });
      }
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let testState = st => {
        switch (Number(st)) {
          case 2:
            return Promise.reject({ level: 2, des: '暂停销售' }); // 暂停销售
          case 3:
            return Promise.reject({ level: 2, des: '停止销售' }); // 停止销售
          case 4:
            // 内部测试:
            // @ts-ignore
            if (userInfo.fict_flag !== 1) {
              return Promise.reject({
                level: 2,
                des: '当前彩种正处于内测阶段，敬请期待!',
              });
            }
        }
        // 可以进入
        return Promise.resolve({ response_code: 9999 });
      };
      const playId = payload.subplayid || payload.main_play_id;

      try {
        const res = await network.request({
          cmdId: 321535,
          data: [tenantInfo.value.tid, payload.main_play_id],
          paramType: 2,
        });
        if (res && res.type === 'success') {
          if (JSON.stringify(res.data) !== JSON.stringify(this.gameTab)) {
            this.gameTab = res.data;
          }
          return testState(res.data[playId]);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 查询收藏
     */
    async checkIsFavorite(payload) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      try {
        const res = await network.request({
          cmdId: 320568,
          data: {
            tid: tenantInfo.value.tid,
            cust_id: userInfo.value.cust_id,
            play_id: payload.play_id,
            play_cat: payload.play_cat,
          },
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 请求彩种当前期信息
     */
    async reqCurrentTerm(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      const gameStore = useGameStore();
      let play = ConfigUtils.getPlayInfo(payload.play_id);
      try {
        const res = await network.request({
          cmdId: 320334,
          data: [tenantInfo.value.tid, play.play_name],
          paramType: 2,
          timeout: payload.timeout || 1000 * 20,
        });
        if (res && res.type === 'success') {
          let newTerm = Object.assign({}, res.data) as any;
          newTerm.startTime = startTime(res.data);
          newTerm.stopTime = stopTime(res.data);
          if (!isFrost(newTerm)) {
            let terms = {} as any;
            terms.key = payload.play_id;
            terms.data = newTerm;
            gameStore.setTerms(terms);
          }
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 请求指定彩种的开奖公告
     */
    async reqTermHistory(payload) {
      let play = ConfigUtils.getPlayInfo(payload.play_id);
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      const gameStore = useGameStore();
      let data = {} as any;
      data.tid = tenantInfo.value.tid;
      data.play_name = play ? play.play_name : payload.play_name;
      data.count = payload.count ? payload.count : 10;
      try {
        const res = await network.request({
          cmdId: 320539,
          data,
          timeout: payload.timeout || 1000 * 20,
        });
        if (res && res.type === 'success') {
          if (res.data && payload.count !== 1) {
            let resCopy: any[] = [];
            for (let i in res.data) {
              let historyItem = Object.assign({}, res.data[i]);
              if (historyItem.play_name.indexOf('K3') !== -1) {
                let code1 = parseInt(historyItem.win_code.slice(0, 1));
                let code2 = parseInt(historyItem.win_code.slice(1, 2));
                let code3 = parseInt(historyItem.win_code.slice(2, 3));
                let codeArr = [code1, code2, code3];
                codeArr.sort(function (a, b) {
                  return a - b;
                });
                historyItem.win_code = codeArr.join('');
              }
              historyItem.local_win_code_arr = parseWincode(payload.play_id, historyItem);
              resCopy.push(historyItem);
            }
            let key = 'loop-' + payload.play_id;
            let dataForkey = {};
            dataForkey[key] = resCopy;
            // 为了解决香港彩开奖state一直刷新问题
            let oldData = gameStore.termHistorys;
            if (oldData && oldData[key] && oldData[key].length > 0) {
              if (oldData[key][0].term_code !== resCopy[0].term_code) {
                gameStore.setTermHistorys(dataForkey);
              }
            } else {
              gameStore.setTermHistorys(dataForkey);
            }
          }
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 请求所有子玩法信息详情
     */
    async reqPlayDetailWithUpId(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      const gameStore = useGameStore();
      try {
        const res = await network.request({
          cmdId: 320142,
          data: [tenantInfo.value.tid, payload.up_play_id],
          paramType: 2,
          timeout: payload.timeout || 1000 * 20,
        });
        if (res && res.type === 'success') {
          gameStore.setPlayDetails({ key: 'set', value: res.data });
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 获取游戏个人返点状态
     */
    async reqPersonalRebate(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      const gameStore = useGameStore();
      try {
        const res = await network.request({
          cmdId: 321544,
          data: {
            tid: tenantInfo.value.tid,
            play_id: payload.play_id,
          },
        });
        if (res && res.type === 'success') {
          let obj = {};
          obj[payload.play_id] = res.data === 1;
          gameStore.setPersonalRebateStatus(obj);
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    async reqBetFromBasket(payload, onlyGetRequestParameters = false) {
      const { hotData } = useHot();
      const { userInfo, tenantInfo } = hotData;
      const gameStore = useGameStore();
      const sportsStore = useSportsStore();

      let tid = tenantInfo.value.tenant.tid;
      let custId = userInfo.value.cust_id;
      let custCode = userInfo.value.cust_code;
      let key = payload.main_play_id;
      if (payload.key) {
        key = payload.key;
      }
      let roomLevel = 0;
      let playRoomId = 0;
      if (payload.room_level || payload.room_level === 0) {
        roomLevel = payload.room_level;
      }
      if (payload.play_room_id) {
        playRoomId = payload.play_room_id;
      }
      let termCode = null;
      let termPart = null;
      let isSale = this.termsStatus[payload.main_play_id];
      if (payload.term_code) {
        termCode = payload.term_code;
        if (payload.term_part) {
          termPart = payload.term_part;
          isSale = true;
        }
      } else {
        let term = this.terms[payload.main_play_id];
        if (term) {
          termCode = term.term_code;
          termPart = term.part_mon;
        }
      }
      let basket = this.baskets[key];

      if (basket == null) {
        return Promise.reject({ tag: 'Basket Bet 1', info: '请至少选择一注' });
      }
      if (basket.items && basket.items[payload.basketItemKey]) {
        let items = {};
        items[payload.basketItemKey] = basket.items[payload.basketItemKey];
        basket = { ...basket, keys: [payload.basketItemKey], items: items };
      }
      basket = Object.assign({}, basket);
      // 跟注修改金额时
      if (payload.basket) {
        basket = payload.basket;
      }
      let localerr: any = null;

      if (basket.keys == null || basket.keys.length === 0) {
        return Promise.reject({ tag: 'Basket Bet 2', info: '请至少选择一注' });
      }

      if (custId == null || custCode == null)
        localerr = {
          tag: 'Basket Bet 4',
          info: '用户信息出错!',
        };
      else if (termCode == null) localerr = { tag: 'Basket Bet 5', info: '无法获得期号信息' };
      else if (!isSale) localerr = { tag: 'Basket Bet 6', info: '当前期正在摇奖中，无法投注!' };
      else if (basket.length === 0) localerr = { tag: 'Basket Bet 7', info: '号码栏为空' };
      else if (basket.total_note < 1) localerr = { tag: 'Basket Bet 8', info: '请至少选择一注' };
      if (localerr) {
        return Promise.reject(localerr);
      }
      let mainPlay = ConfigUtils.getPlayInfo(payload.main_play_id);
      let isLHC = mainPlay.cat === 'MARKSIX' || mainPlay.cat === 'LHCJDC';
      let isYDC = mainPlay.cat === 'YDC';
      let changeMultix = isMobile() && payload.ticketListAmountData && !isLHC && !isYDC;
      let plan = createPlan(payload.main_play_id, basket.multx, termCode, termPart, changeMultix);
      plan.lineTickets = []; // 解决折方案问题
      plan.room_level = roomLevel;
      plan.play_room_id = playRoomId;
      let isComAmount = false;
      for (let i = 0; i < basket.keys.length; i++) {
        let key = basket.keys[i];
        let basketItem = basket.items[key];
        let subPlay = ConfigUtils.getPlayInfo(basketItem.subplayid);
        // 特殊处理快3的和值玩法
        let noteMultx = changeMultix ? basket.multx : basketItem.multx;
        let basketMultx = changeMultix ? 1 : basket.multx;
        let tickets: any[] = [];
        plan.lineTickets.push(tickets);
        if (subPlay.cmd_signal_ball && !payload.isLR) {
          // 再剃掉利润率追号
          basketItem.ball_ids.map(item => {
            let newItem = Object.assign({}, basketItem);
            newItem.ball_ids = [item];
            newItem.note = 1;
            newItem.multx = noteMultx;
            let playTicket = {} as any;
            // 单独设置金额start
            let ballPrice = 1;
            let unitBallId = basketItem.subplayid + '-' + item;
            if (payload.ticketListAmountData) {
              payload.ticketListAmountData.useKey && (unitBallId = key + unitBallId);
              for (let tKey in payload.ticketListAmountData) {
                // eslint-disable-next-line no-prototype-builtins
                if (payload.ticketListAmountData.hasOwnProperty(tKey)) {
                  if (tKey === unitBallId) {
                    ballPrice = Number(payload.ticketListAmountData[tKey].amount) * payload.quickUnit;
                  }
                }
              }
            }
            // 单独设置金额end
            playTicket.ticket_id = 0;
            playTicket.ticket_code = 0;
            playTicket.note_num = 1;
            playTicket.multx = noteMultx;
            playTicket.play_name = subPlay.play_name;
            playTicket.play_id = subPlay.id;
            playTicket.play_cname = subPlay.play_cname;
            playTicket.play_cmd = getBasketItemCMD(payload.main_play_id, null, newItem) + '#B' + basketMultx;
            playTicket.tid = tid;
            playTicket.num = subPlay.simplex ? '' : JSON.stringify([newItem.ball_ids]);
            playTicket.rebate = newItem.rebate ? newItem.rebate : 0;
            if (payload.theme && payload.theme === 'themeDZ') {
              playTicket.note_price = basketItem.unit_price * 1000 * ballPrice * payload.plan_multx;
            } else {
              playTicket.note_price = basketItem.unit_price * 1000 * ballPrice;
            }
            plan.playPlanTickets.push(playTicket);
            tickets.push(playTicket);
          });
          // 六 合 彩对碰类玩法
        } else if (isPairBall(basketItem.subplayid)) {
          let pairballs = helperHK.getPairBalls(basketItem.subplayid, basketItem.ball_ids);
          // 单独设置金额start
          let unitBallId = basketItem.subplayid + '-' + JSON.stringify(pairballs);
          let ballPrice = 1;
          if (payload.ticketListAmountData) {
            payload.ticketListAmountData.useKey && (unitBallId = key + unitBallId);
            for (let tKey in payload.ticketListAmountData) {
              // eslint-disable-next-line no-prototype-builtins
              if (payload.ticketListAmountData.hasOwnProperty(tKey)) {
                if (tKey === unitBallId) {
                  ballPrice = Number(payload.ticketListAmountData[tKey].amount) * payload.quickUnit;
                }
              }
            }
          }
          // 单独设置金额end
          pairballs.map(item => {
            let newItem = Object.assign({}, basketItem);
            newItem.note = 1;
            let playTicket = {} as any;
            playTicket.ticket_id = 0;
            playTicket.ticket_code = 0;
            playTicket.note_num = 1;
            playTicket.multx = noteMultx;
            playTicket.play_name = subPlay.play_name;
            playTicket.play_id = subPlay.id;
            playTicket.play_cname = subPlay.play_cname;
            playTicket.play_cmd =
              basketItem.subplayid + '#' + item[0] + item[1] + '*1*' + noteMultx + '#B' + basketMultx;
            playTicket.tid = tid;
            playTicket.num = JSON.stringify([item]);
            playTicket.rebate = newItem.rebate ? newItem.rebate : 0;
            playTicket.note_price = basketItem.unit_price * 1000 * ballPrice;
            plan.playPlanTickets.push(playTicket);
            tickets.push(playTicket);
          });
        } else {
          // 单独设置金额start
          let arrCodes: any[] = [];
          let allAreaBalls = ballsWithArea(basketItem.subplayid, basketItem.ball_ids);
          for (let j in allAreaBalls) {
            let balls = allAreaBalls[j];
            let tmpStr = '';
            for (let k = 0; k < balls.length; k++) {
              let ball = balls[k];
              tmpStr += ball.id;
            }
            if (balls.length > 0) {
              arrCodes.push(tmpStr);
            }
          }
          let unitBallId = basketItem.subplayid + '-' + arrCodes.join(',');
          let ballPrice = 1;
          if (payload.ticketListAmountData) {
            payload.ticketListAmountData.useKey && (unitBallId = key + unitBallId);
            for (let tKey in payload.ticketListAmountData) {
              // eslint-disable-next-line no-prototype-builtins
              if (payload.ticketListAmountData.hasOwnProperty(tKey)) {
                if (tKey === unitBallId) {
                  ballPrice = Number(payload.ticketListAmountData[tKey].amount) * payload.quickUnit;
                }
              }
            }
          }
          // 单独设置金额end
          let playTicket = {} as any;
          playTicket.ticket_id = 0;
          playTicket.ticket_code = 0;
          playTicket.note_num = basketItem.note;
          playTicket.multx = noteMultx;
          playTicket.play_name = subPlay.play_name;
          playTicket.play_id = subPlay.id;
          playTicket.play_cname = subPlay.play_cname;
          playTicket.play_cmd =
            getBasketItemCMD(payload.main_play_id, null, {
              ...basketItem,
              multx: noteMultx,
            }) +
            '#B' +
            basketMultx;
          playTicket.tid = tid;
          playTicket.num = subPlay.simplex ? '' : JSON.stringify([basketItem.ball_ids]);
          playTicket.rebate = basketItem.rebate ? basketItem.rebate : 0;
          playTicket.note_price = basketItem.unit_price * 1000 * ballPrice;
          plan.playPlanTickets.push(playTicket);
          tickets.push(playTicket);
        }
        if (basketItem && !isComAmount) {
          for (let i in basketItem.ball_ids) {
            let ballInfo = ConfigUtils.getBallInfo(basketItem.subplayid);
            let ball = ballInfo.balls[Number(basketItem.ball_ids[i])];
            if (ball && ball.is_com_amount) {
              isComAmount = true;
              break;
            }
          }
        }
      }
      if (payload.totalAmount) {
        // 单独设置金额注单的总金额
        plan.amount = payload.totalAmount;
      } else {
        plan.amount = basket.total_amount;
      }
      plan.note_num = basket.total_note;
      plan.per_amount = plan.amount;
      plan.com_amount = isComAmount ? plan.amount : 0;
      if (payload.options) {
        plan = Object.assign(plan, payload.options);
      }
      plan.platform = getBetPlatform();
      if (basket.IS_CHAT_FLOW_TICKET) {
        plan.playPlanTickets = plan.playPlanTickets.map(ele => {
          ele.note_price = basket.specical_note_price;
          return ele;
        });
      }

      if (payload.lineTicketsChange && plan.lineTickets[0].length > 0) {
        // 重新组装lineTickets（和pc保持一致）
        const newLineTickets: any[] = [];
        plan.lineTickets[0].forEach(obj => {
          newLineTickets.push([obj]);
        });
        plan.lineTickets = newLineTickets;
      }

      let key2 = payload.main_play_id;
      if (payload.key) {
        key2 = payload.key;
      }

      // 返回投注参数 用于分享投注和跟单展示
      if (onlyGetRequestParameters) {
        return sliptPlanWithSubPlay(plan);
      }

      try {
        const res: any = await network.request({
          cmdId: 320604,
          data: sliptPlanWithSubPlay(plan),
          paramType: 1,
        });
        console.log('reqBetFromBasket', res, sliptPlanWithSubPlay(plan));
        if (res && res.type === 'success') {
          if (payload.basketItemKey !== -1) {
            gameStore.removeItemFromBasket({
              main_play_id: payload.main_play_id,
              key: key2,
              rom_key: payload.basketItemKey,
            });
          } else {
            gameStore.clearBasketWithPlayId({ main_play_id: payload.main_play_id, key: key2 });
          }
          res.data.plan = plan;
          res.data.basket = basket;
          sportsStore.reqBlanceCollect();
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 请求走势图
     */
    async reqCharts(payload) {
      let isApp = true;
      if (payload.isPC === true) {
        isApp = false;
      }
      let key = payload.key ? payload.key : payload.play_id;
      let trendCode: any = null;
      let play = ConfigUtils.getPlayInfo(payload.play_id);
      if (play) {
        let trendCfg = ConfigUtils.getChartConfig(play.cat, isApp);
        if (trendCfg && trendCfg.trends[parseInt(payload.trend_idx)]) {
          let trendId = trendCfg.trends[parseInt(payload.trend_idx)].trend;
          let chartid = payload.play_id;
          if (play.chartid) {
            chartid = play.chartid;
          }
          trendCode = chartid + '_' + trendId;
        }
      }
      if (trendCode) {
        try {
          const res: any = await network.request({
            cmdId: 321833,
            data: { trend_code: trendCode, num: payload.num },
          });
          if (res && res.type === 'success') {
            if (res.data && res.data.trendInstList) {
              for (let i in res.data.trendInstList) {
                res.data.trendInstList[i].trends_map = JSON.parse(res.data.trendInstList[i].trends_map);
                if (res.data.trend_name.indexOf('K3') !== -1) {
                  let code1 = parseInt(res.data.trendInstList[i].win_code.slice(0, 1));
                  let code2 = parseInt(res.data.trendInstList[i].win_code.slice(1, 2));
                  let code3 = parseInt(res.data.trendInstList[i].win_code.slice(2, 3));
                  let codeArr = [code1, code2, code3];
                  codeArr.sort(function (a, b) {
                    return a - b;
                  });
                  res.data.trendInstList[i].win_code = codeArr.join('');
                }
              }
              const gameStore = useGameStore();
              gameStore.setCharts({ key: key, data: res.data });
            }
            return Promise.resolve(res.data);
          }
        } catch (error: any) {
          return Promise.reject(error.data);
        }
      } else {
        return Promise.reject({});
      }
    },
    /**
     * 请求房间类型列表
     */
    async reqChatByNames(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      const gameStore = useGameStore();
      try {
        const res: any = await network.request({
          cmdId: 321137,
          data: {
            tid: tenantInfo.value.tid,
            play_names: payload.play_names,
          },
        });
        if (res && res.type === 'success') {
          gameStore.setRoomCat(res.data);
          return Promise.resolve(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 请求盈利榜分页
     */
    async reqProfitListPage(payload = {}) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      if (!tenantInfo.value.tid) return;
      let data = {
        ...payload,
        tid: tenantInfo.value.tid,
      };
      try {
        const res: any = await network.request({
          cmdId: 341534,
          data,
          paramType: 0,
          headerType: 1,
        });
        if (res && res.type === 'success') {
          // this.profitList = res.data || [];
          return Promise.resolve(res.data || []);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    // 获取原创游戏
    async reqOriginalGames(payload = {} as any) {
      const { hotData } = useHot();
      const { tenantInfo, userInfo } = hotData;
      let data = {
        tid: tenantInfo.value.tid,
      } as any;
      if (userInfo.value?.cust_id) {
        data.cust_id = userInfo.value.cust_id;
      }
      try {
        const res: any = await network.request({
          cmdId: 470110,
          data,
        });
        if (res && res.type === 'success') {
          this.setOriginalGames(res.data);
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
  },
});
